/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const TodayBtnList = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 8px 24px 8px 8px;
  cursor: default;
  gap: 1px;
`;

export const EmptySpace = styled.div`
  height: 100%;
  background: #fff;
`;
